var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { checkPageContentLength, createSnapshotThunk, overridePageAction } from '@/actions';
import { getShield } from '@/helpers';
export default (function (payload) { return function (dispatch, getState) {
    var e_1, _a, _b, e_2, _c, _d;
    var section = payload.section, width = payload.width;
    var _e = getState().core, pages = _e.pages, pagesSelection = _e.pagesSelection;
    var currentPage = pages[pagesSelection[0]];
    var layouts = currentPage.layouts;
    var shield = getShield(layouts, section.shieldId);
    var sectionsMap = currentPage.sections;
    var shieldWidth = shield.primitiveProps.w;
    var shieldX = shield.primitiveProps.x;
    var sectionList = Object.values(sectionsMap).filter(function (s) { return s.shieldId === shield.id; });
    var sorted = __spreadArray([], __read(sectionList), false).sort(function (a, b) { return a.x - b.x; });
    var changedIdx = sorted.findIndex(function (s) { return s.id === section.id; });
    dispatch(createSnapshotThunk());
    if (shield.isMatrixFixedCellWidth) {
        var clampedNewWidth = Math.max(0, Number(width));
        sorted[changedIdx].width = clampedNewWidth;
        var x = shieldX;
        try {
            for (var sorted_1 = __values(sorted), sorted_1_1 = sorted_1.next(); !sorted_1_1.done; sorted_1_1 = sorted_1.next()) {
                var s = sorted_1_1.value;
                s.x = x;
                x += s.width;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (sorted_1_1 && !sorted_1_1.done && (_a = sorted_1.return)) _a.call(sorted_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        dispatch(overridePageAction({
            page: __assign(__assign({}, currentPage), { sections: __assign(__assign({}, currentPage.sections), sectionsMap), sectionsSelection: (_b = {}, _b[sorted[changedIdx].id] = sorted[changedIdx], _b) }),
        }));
        dispatch(checkPageContentLength(currentPage.uid));
    }
    else {
        var clampedNewWidth = Math.max(0, Math.min(Number(width), shieldWidth));
        sorted[changedIdx].width = clampedNewWidth;
        var otherSections = sorted.filter(function (_, i) { return i !== changedIdx; });
        var otherTotalWidth = otherSections.reduce(function (sum, s) { return sum + s.width; }, 0);
        var remainingWidth = shieldWidth - clampedNewWidth;
        if (otherSections.length > 0 &&
            otherTotalWidth > 0 &&
            remainingWidth >= 0) {
            var scale_1 = remainingWidth / otherTotalWidth;
            otherSections.forEach(function (s) {
                s.width = s.width * scale_1;
            });
        }
        var x = shieldX;
        try {
            for (var sorted_2 = __values(sorted), sorted_2_1 = sorted_2.next(); !sorted_2_1.done; sorted_2_1 = sorted_2.next()) {
                var s = sorted_2_1.value;
                s.x = x;
                x += s.width;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (sorted_2_1 && !sorted_2_1.done && (_c = sorted_2.return)) _c.call(sorted_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        dispatch(overridePageAction({
            page: __assign(__assign({}, currentPage), { sections: __assign(__assign({}, currentPage.sections), sectionsMap), sectionsSelection: (_d = {}, _d[sorted[changedIdx].id] = sorted[changedIdx], _d) }),
        }));
    }
}; });
